/**
 * TanStack Query hooks for `opinion-universe-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	opinionUniverseIntegrationQueryKeys,
	type CreateOpinionUniverseIntegrationBody,
	type ListOpinionUniverseIntegrationResponse,
	type OpinionUniverseIntegrationRow,
} from "./api";

export function useOpinionUniverseIntegrationList(): UseQueryResult<ListOpinionUniverseIntegrationResponse, Error> {
	return useQuery({
		queryKey: opinionUniverseIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useOpinionUniverseIntegrationCreate(): UseMutationResult<OpinionUniverseIntegrationRow, Error, CreateOpinionUniverseIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: opinionUniverseIntegrationQueryKeys.all });
		},
	});
}

export function useOpinionUniverseIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: opinionUniverseIntegrationQueryKeys.all });
		},
	});
}
